import React from 'react';
import { StyledSvgIcon } from '../icon.styles';
import { customIconsPropTypes } from './customicons.propTypes';

const PagesIcon = ({ fontSize, color, sx, title }) => (
  <StyledSvgIcon
    fontSize={fontSize}
    color={color}
    titleAccess={title}
    data-testid={title}
    aria-label={title}
    sx={sx}
  >
    <svg viewBox="0 0 110 110" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M39.1 2H7.3C5.89435 2 4.54628 2.55839 3.55233 3.55233C2.55839 4.54628 2 5.89435 2 7.3V39.1C2 40.5056 2.55839 41.8537 3.55233 42.8477C4.54628 43.8416 5.89435 44.4 7.3 44.4H39.1C40.5056 44.4 41.8537 43.8416 42.8477 42.8477C43.8416 41.8537 44.4 40.5056 44.4 39.1V7.3C44.4 5.89435 43.8416 4.54628 42.8477 3.55233C41.8537 2.55839 40.5056 2 39.1 2ZM39.1 65.6H7.3C5.89435 65.6 4.54628 66.1584 3.55233 67.1523C2.55839 68.1463 2 69.4944 2 70.9V102.7C2 104.106 2.55839 105.454 3.55233 106.448C4.54628 107.442 5.89435 108 7.3 108H39.1C40.5056 108 41.8537 107.442 42.8477 106.448C43.8416 105.454 44.4 104.106 44.4 102.7V70.9C44.4 69.4944 43.8416 68.1463 42.8477 67.1523C41.8537 66.1584 40.5056 65.6 39.1 65.6ZM102.7 2H70.9C69.4944 2 68.1463 2.55839 67.1523 3.55233C66.1584 4.54628 65.6 5.89435 65.6 7.3V39.1C65.6 40.5056 66.1584 41.8537 67.1523 42.8477C68.1463 43.8416 69.4944 44.4 70.9 44.4H102.7C104.106 44.4 105.454 43.8416 106.448 42.8477C107.442 41.8537 108 40.5056 108 39.1V7.3C108 5.89435 107.442 4.54628 106.448 3.55233C105.454 2.55839 104.106 2 102.7 2Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="4"
        strokeLinejoin="round"
      />
      <path
        d="M65.5996 65.5996H108H65.5996ZM86.7996 86.7996H108H86.7996ZM65.5996 108H108H65.5996Z"
        fill="currentColor"
      />
      <path
        d="M65.5996 65.5996H108M86.7996 86.7996H108M65.5996 108H108"
        stroke="currentColor"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </StyledSvgIcon>
);
export default PagesIcon;

PagesIcon.propTypes = customIconsPropTypes;
